import { useContext, useEffect, useState } from "react";
import { EnvironmentContext, environments } from "../../../config/EnvironmentContext";
import { useToken } from "./token";

export const useGetTitle = (input, value, field, result) => {
  const { token } = useToken();
  const [getTitle, setTitle] = useState("");
  const { readBody = (body) => body.json() } = {};
  const env = useContext(EnvironmentContext);
  const abortController = new AbortController();
  const signal = abortController.signal;

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    (async () => {
      if (input && token) {
        let url = environments.location[env] + input;
        let tokenType = token.tokenType.charAt(0).toUpperCase() + token.tokenType.substr(1).toLowerCase();
        try {
          const response = await fetch(url, {
            headers: {
              Authorization: tokenType + " " + token.token,
            },
            signal: signal,
          });
          if (response.ok) {
            const body = await readBody(response);
            body.data.forEach((item) => {
              if (item[field] === value) {
                setTitle(item[result]);
              }
            });
          } else {
            const body = await readBody(response);
            console.log("error", body);
          }
        } catch (e) {
          console.log("E", e);
        }
      }
    })();
  }, [input, token]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  return { getTitle };
};
